import React from "react";
import { cn } from "../../lib/cn";

const VARIANTS = {
  display: "text-4xl sm:text-5xl lg:text-6xl font-semibold leading-[1.04] tracking-tightest",
  section: "text-3xl sm:text-4xl font-semibold leading-[1.1] tracking-tighter",
  title: "text-2xl font-semibold leading-tight tracking-tight",
  subtitle: "text-lg font-semibold tracking-tight",
};

/**
 * Display heading in Inter Tight. Wrap accent words with
 * <em className="kbc-serif">word</em> for the Instrument-Serif italic flourish.
 */
export function Heading({ as, variant = "section", className, children, balance = true, ...props }) {
  const Comp = as || (variant === "display" ? "h1" : variant === "title" || variant === "subtitle" ? "h3" : "h2");
  return (
    <Comp
      className={cn("font-display text-ink", VARIANTS[variant], balance && "text-balance", className)}
      {...props}
    >
      {children}
    </Comp>
  );
}

export default Heading;
